import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import constants from '../../../../constants';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/certificateType01/registerUseCase';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import CertificateType01RegisterView from './CertificateType01RegisterView';
import routes from '../../../../../../components/Routes/routingMap';

const CertificateType01RegisterViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();

  // states
  const [selectedPeriod, setSelectedPeriod] = React.useState(null);
  const [showConfirmCancel, setShowConfirmCancel] = React.useState(false);

  // selectors
  const { procedure: procedureSelectedInfo, selectedProcedureId } = useSelector(
    (state: any) => state.procedureInformation
  );

  const {
    isLoading: isLoadingRegister,
    requestId: requestIdRegistered,
    isSuccess: isSuccessRegister
  } = useSelector((state: any) => state.registerCertificateType01);
  // effects
  React.useEffect(() => {
    if (!procedureSelectedInfo) {
      const selectedCertificate =
        constants.categories.certificates.type1List.find(
          (p) => p.url === params.certificatetype01name
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedCertificate?.procedureId
        )
      );
    }
  }, []);

  React.useEffect(() => {
    if (isSuccessRegister && requestIdRegistered) {
      const certificateFound = constants.categories.certificates.type1List.find(
        (p) => p.procedureId === procedureSelectedInfo?.id
      );
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          procedureSelectedInfo?.id,
          requestIdRegistered
        )
      );
      history.push(
        routes.student.procedures.categories.certificates.certificatetype01.procedureprogress.replace(
          ':certificatetype01name',
          certificateFound?.url || procedureSelectedInfo?.id
        )
      );
    }
  }, [isSuccessRegister]);

  // constants
  const selectedCertificate = constants.categories.certificates.type1List.find(
    (p) => p.procedureId === selectedProcedureId
  );

  // handlers
  const handlerChangePeriod = (period: any) => {
    setSelectedPeriod(period);
  };

  const handlerBackButton = () => {
    if (selectedPeriod) {
      setShowConfirmCancel(true);
    } else {
      history.goBack();
    }
  };

  const handlerBackButtonConfirm = (accept: boolean) => {
    if (accept)
      history.push(`/tramites/autogestionables/${selectedCertificate?.url}`);
    else setShowConfirmCancel(false);
  };

  const handlerRegister = () => {
    dispatch(
      registerActions.registerCertificateOfStudies(
        procedureSelectedInfo.id,
        selectedPeriod,
        procedureSelectedInfo?.detail?.program || '',
        procedureSelectedInfo?.detail?.weightedAverage?.toString() || '',
        procedureSelectedInfo?.detail?.hasDebts || null
      )
    );
  };

  const handlerRegisterAutoPeriod = () => {
    dispatch(
      registerActions.registerCertificateOfStudies(
        procedureSelectedInfo.id,
        {
          value: procedureSelectedInfo?.detail?.periodId?.toString() || '',
          label: procedureSelectedInfo?.detail?.periodDesc || ''
        },
        procedureSelectedInfo?.detail?.program || '',
        procedureSelectedInfo?.detail?.weightedAverage?.toString() || '',
        procedureSelectedInfo?.detail?.hasDebts || null
      )
    );
  };

  return (
    <CertificateType01RegisterView
      procedureSelectedInfo={procedureSelectedInfo}
      selectedPeriod={selectedPeriod}
      handlerChangePeriod={handlerChangePeriod}
      handlerBackButton={handlerBackButton}
      handlerBackButtonConfirm={handlerBackButtonConfirm}
      isProcessing={isLoadingRegister}
      showConfirmCancel={showConfirmCancel}
      handlerRegister={handlerRegister}
      handlerRegisterAutoPeriod={handlerRegisterAutoPeriod}
    />
  );
};

export default CertificateType01RegisterViewController;
